import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import DownloadLink from "../../../util/downloader/DownloadLink";
import {
  Grid,
  Divider,
  Box,
  AppBar,
  Tabs,
  Tab,
  Chip,
  CircularProgress,
  Button,
  Snackbar,
} from "@material-ui/core";
// import trackfields from "../../../_module/definition/trackFields";
import clsx from "clsx";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
// import trackField from "../../../_module/definition/trackFields";
import { Link } from "react-router-dom";
import moment from "moment";
import TrackPreview from "../../../util/content-util/TrackPreview";
import Columns from "./Columns";
import { ColumnTypes } from "../../../util/table-view/TableTypes";
import Moment from "react-moment";
import PlayerRef from "../../ml-player/PlayerRef/PlayerRef";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import CtagRulePreview from "../../../util/c-tag-util/CtagRulePreview";
import CliIcon from "images/sky-music.png";
import CliIconMain from "images/artwork.png";
import {
  showCtagRulePreview,
  getTrackHistory,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  search,
  setQuery,
  prsSetHistory,
  focusItem,
  updatePrsData,
  getActivityCounts,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
} from "../../../redux/actions/MlTrackLibraryActions";
import { __getTrackStatusByID } from "../../../_clearance/utils/utils";
import TrackSearchHistory from "../../../util/history/TrackSearchHistory";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
import { AuthSrc } from "./../../../util/AuthSrc";
import { getContributorDetails, getUserNameWithDetails } from "util/CommonFunc";
import { getChangeLogDetails } from "./../../../util/CommonFunc";

import MetaDataPopOut from "../../../_module/component/metadata-popout/metadata-popout";
import { PageTableType } from "redux/Types";
import { BiDownload } from "react-icons/bi";
import {
  getDownloadBookletLink,
  clearDownloads,
} from "redux/actions/DownloadActions";
import {
  getTrafficLightColor,
  getTrafficLightLabel,
} from "_module/component/traffic-light-info-box/traffic-light-info-box";
import TextElement from "util/preview-element/TextElement";
import { MdCheck, MdOutlineClose, MdOutlineHighlightOff } from "react-icons/md";
import PrsPopup from "_module/component/prs-popup/prs-popup";
import { appConfig } from "App";
import PrsDataPreview from "util/PrsDataPreview";
import ActivityCounts from "util/activity-counts-elemets/activityCounts";
import { getUserDisplay } from "util/CommonFunc";
import TrackMetadataGrid from "_module/component/track-metadata-grid/track-metadata-grid";
import { DurationDisplayText } from "util/DurationDisplay";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={4}>{children}</Box>}
    </div>
  );
}

class Preview extends Component {
  columns;
  constructor(props) {
    super();
    this.state = {
      tabValue: props.isPopOut && props.isInline ? 7 : 0,
      doUpdate: true,
      errorMessage: null,
      bookletDlLoading: false,
    };
    this.columns = props.orgRuntime?.runtime?._TrackColumns || Columns;
  }

  colsDef = null;
  colsDefAll = null;
  trackHistBusy = false;

  generateColsDef(origin) {
    const {
      orgRuntime: {
        runtime: {
          _settingMetadataConditional: _settingMetadataConditional,
          _settingMetadataFieldsDefault: _settingMetadataFieldsDefault,
          _settingMetadataFieldsCommercial: _settingMetadataFieldsCommercial,
          _settingMetadataFieldsLibrary: _settingMetadataFieldsLibrary,
          _settingMetadataFieldsCommissioned:
          _settingMetadataFieldsCommissioned,
          _mlMetadata,
          _trackMetadataConfig,
          commercialMusicOrigins,
          productionLibMusicOrigins,
          commisionedMusicOrigins,
        },
      },
    } = this.props;
    this.colsDefAll = [];
    this.colsDef = [];

    const metaDataSetting = _PermittedContent(
      [_mlMetadata, _trackMetadataConfig],
      []
    ) || { setting: [] };
    this.colsDefAll = this.colsDef =
      _PermittedSetting(
        metaDataSetting.setting,
        _settingMetadataFieldsDefault
      ) || [];

    if (
      _PermittedSetting(metaDataSetting.setting, _settingMetadataConditional) ||
      false
    ) {
      // if (origin.startsWith("library") )
      if (productionLibMusicOrigins?.includes(origin)) {
        // this.colsDef = this.colsDefAll;
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsLibrary
          ) || this.colsDefAll;
      }
      // else if (origin.startsWith("commercial"))
      else if (commercialMusicOrigins?.includes(origin)) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommercial
          ) || this.colsDefAll;
      }
      // else if (origin.startsWith("commissioned"))
      else if (commisionedMusicOrigins?.includes(origin)) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommissioned
          ) || this.colsDefAll;
      }
    }
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
    } = this.props;
    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
  }

  componentDidUpdate(prevProps) {
    let selectedItem;
    const {
      data: { showCtagRule },
      showCtagRulePreview,
      data: { selectedItem: selectedItemForPreview, postUpdating, history },
      getTrackHistory,
      clearDownloads,
      item,
      isPopOut,
    } = this.props;

    if (isPopOut) {
      selectedItem = item;
    } else {
      selectedItem = selectedItemForPreview;
    }

    if (showCtagRule) {
      this.setState({ tabValue: 3, doUpdate: false });
      showCtagRulePreview(false);
    }

    if (selectedItem && selectedItem.id && !(selectedItem.id in history)) {
      if (!this.trackHistBusy) {
        this.trackHistBusy = true;
        getTrackHistory(selectedItem.id, (data, err) => {
          this.trackHistBusy = false;
        });
      }
    }

    if (prevProps?.data?.selectedItem?.id !== selectedItem?.id) {
      clearDownloads();
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  // getUserDisplay(userId) {
  //   const { users } = this.props;
  //   let RefId = users.find((v) => v.userId == userId);
  //   let formattedName = "";
  //   if (RefId) {
  //     let user = users.find((v) => {
  //       if (
  //         v.externalRefId &&
  //         typeof v.externalRefId == "string" &&
  //         typeof RefId.externalRefId == "string"
  //       ) {
  //         return (
  //           v.externalRefId.toLowerCase() == RefId.externalRefId.toLowerCase()
  //         );
  //       }
  //     });
  //     if (user) {
  //       formattedName = getUserNameWithDetails(user);
  //     }
  //   }
  //   return <span title={formattedName}>{formattedName} </span>;
  // }

  renderMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _trackMusicOrigins: trackOrigins,
        },
      },
    } = this.props;
    let column = this.columns[id];
    let value =
      selectedItem[id] && Array.isArray(selectedItem[id])
        ? selectedItem[id].join(", ")
        : selectedItem[id];

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`track.${id}`)}>
          {t(`track.${id}`)}
        </label>
        {selectedItem[id] && Array.isArray(selectedItem[id]) ? (
          selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
        ) : selectedItem[id] ? (
          <span className={classes.muDetails}>{selectedItem[id]}</span>
        ) : (
          ""
        )}
      </div>
    ) : (
      <div key={i} className={clsx(classes.muDetailWrap, "popupData")}>
        <div
          className={clsx(
            id === "title" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={
            id == "bbcTrackId" &&
              (process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == true)
              ? t(
                `track.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }TrackId`
              )
              : id == "bbcAlbumId" &&
                (process.env.REACT_APP_CLIENT_NONBBC ||
                  process.env.REACT_APP_CLIENT_NONBBC == true)
                ? t(
                  `track.${process.env.REACT_APP_CLIENT_NAME
                    ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                    : "bbc"
                  }AlbumId`
                )
                : prop?.label
                  ? prop?.label
                  : t(`track.${id}`)
          }>
          {id == "bbcTrackId" &&
            (process.env.REACT_APP_CLIENT_NONBBC ||
              process.env.REACT_APP_CLIENT_NONBBC == true)
            ? t(
              `track.${process.env.REACT_APP_CLIENT_NAME
                ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                : "bbc"
              }TrackId`
            )
            : id == "bbcAlbumId" &&
              (process.env.REACT_APP_CLIENT_NONBBC ||
                process.env.REACT_APP_CLIENT_NONBBC == true)
              ? t(
                `track.${process.env.REACT_APP_CLIENT_NAME
                  ? process.env.REACT_APP_CLIENT_NAME.toLowerCase()
                  : "bbc"
                }AlbumId`
              )
              : prop?.label
                ? prop?.label
                : t(`track.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === trackFields.prodName.id ? (
          <div
            className={clsx(
              id === trackFields.prodName.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {((selectedItem?.is_mcf_track == true || selectedItem?.mlCreated == true) ?
              <strong class="tablesLink">{value || ""}</strong> :
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={selectedItem.id}
                to={`/search/album/${selectedItem.prodId}`}>
                <strong class="tablesLink">{value || ""}</strong>
              </Link>
            )}
          </div>
        ) : id === trackFields.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""}
          </div>
        ) : id == trackFields.contributorsExtended.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.contributorsExtended
              ? getContributorDetails(selectedItem.contributorsExtended)
              : ""}
          </div>
        ) : id == trackFields.changeLog.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {selectedItem.changeLog
              ? getChangeLogDetails(selectedItem.changeLog)
              : ""}
          </div>
        ) : id == trackFields.skyTracfficLight.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={value ? getTrafficLightLabel(value) : "N/A"}>
            <span
              style={{
                backgroundColor: value ? getTrafficLightColor(value) : "",
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                marginRight: "8px",
                display: "inline-block",
                verticalAlign: "middle",
              }}></span>
            {value ? getTrafficLightLabel(value) : "N/A"}
          </div>
        ) 
        // : id === trackFields.org_sky_PPL.id ||
        //   id === trackFields.org_sky_MCPS.id ? (
        //   <div
        //     className={clsx(
        //       id === "title" ? classes.muDetailsBold : classes.muDetails,
        //       classes.muDetails
        //     )}
        //     title={value || ""}>
        //     {value == true ? (
        //       "Yes"
        //     ) : value == false && id === trackFields.org_sky_MCPS.id ? (
        //       <span className={classes.nonMCPSPPL}>Non-MCPS</span>
        //     ) : value == false && id === trackFields.org_sky_PPL.id ? (
        //       <span className={classes.nonMCPSPPL}>Non-PPL</span>
        //     ) : (
        //       ""
        //     )}
        //   </div>
        // ) 
        : id === trackFields.org_sky_prodIsPPLBlanket.id ||
          id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={value || ""}>
            {value == true ? (
              ""
            ) : value == false && id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
            ) : value == false && id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <span className={classes.nonMCPSPPL}>Non-PPL</span>
            ) : (
              ""
            )}
          </div>
        ) : trackFields[id] && trackFields[id].linkable ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}>
            {value &&
              value.split(",").map((data, i, array) => (
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  key={`${i}_${data}`}
                  aria-label={`Open Link ${t(`track.${id}`)}: ${data}`}
                  title={data}
                  to={{
                    pathname: `/search/tracks/${encodeURI(
                      data.trim().replace("/", "")
                    )}/${id}`,
                    state: {
                      q: `${data.trim()}`,
                      autofocus: false,
                    },
                  }}>
                  <strong class="tablesLink">
                    {data}
                    {i === array.length - 1 ? null : ", "}
                  </strong>
                </Link>
              ))}
          </div>
        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === trackFields.musicOrigin.id && value
                  ? t(`modules.originLables.${value}`)
                  : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.users ? (
              value ? (
                getUserDisplay(String(value))
              ) : null
            ) : id === trackFields.musicOrigin.id && value ? (
              trackOrigins[value] && trackOrigins[value].label ? (
                trackOrigins[value].label
              ) : trackOrigins["origin" + value] &&
                trackOrigins["origin" + value].label ? (
                trackOrigins["origin" + value].label
              ) : (
                t(`modules.originLables.${value}`)
              )
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false &&
                  id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_MCPS.id ||
              id === trackFields.org_sky_PPL.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {/* {value == true ? (
                  // "Yes"
                  "No" //ML20-6858
                ) : value == false && id === trackFields.org_sky_MCPS.id ? (
                  // <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                  <span className={classes.nonMCPSPPL}>Yes</span> //ML20-6858
                ) : value == false &&
                  id === trackFields.org_sky_PPL.id ? (
                  // <span className={classes.nonMCPSPPL}>Non-PPL</span>
                  <span className={classes.nonMCPSPPL}>Yes</span> //ML20-6858
                ) : (
                  ""
                )} */}
               {value == true ? (
                  id === trackFields.org_sky_MCPS.id ? "No" : selectedItem["pplStatusMigrated"] == true ? "No (manual)" : "No"
                ) : value == false && id === trackFields.org_sky_MCPS.id ? (
                  <span className={classes.nonMCPSPPL}>Yes</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span> //ML20-6858
                ) : value == false &&
                  id === trackFields.org_sky_PPL.id ? (
                selectedItem["pplStatusMigrated"] == true ?
              <span><span className={classes.nonMCPSPPL}>Yes</span> (manual)</span> : <span className={classes.nonMCPSPPL}>Yes</span>
                  // <span className={classes.nonMCPSPPL}>Yes</span> //ML20-6858
                ) : (
                  ""
                )}
              </div>
            ) : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
              id === trackFields.org_sky_prodIsPPLBlanket.id ? (
              <div
                className={clsx(
                  id === trackFields?.prodName?.id
                    ? classes.muDetailsBold
                    : classes.muDetails,
                  classes.muDetails
                )}
                title={value || ""}>
                {value == true ? (
                  ""
                ) : value == false && id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                ) : value == false &&
                  id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                  <span className={classes.nonMCPSPPL}>Non-PPL</span>
                ) : (
                  ""
                )}
              </div>
            ) : column?.type === ColumnTypes.boolean ? (
              value || value == true ? (
                "True"
              ) : value == false ? (
                "False"
              ) : (
                ""
              )
            ) : value !== undefined && value !== null ? (
              value
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  renderAdminNotes = (selectedItem, classes, t) => {
    return (
      <>
        <div className={clsx(classes.muDetailWrap, "popupData")}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Admin Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcAdminNotes || ""}>
            {selectedItem?.bbcAdminNotes || ""}
          </div>
        </div>
        <div className={clsx(classes.muDetailWrap, "popupData")}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Librarian Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLibrarianNotes || ""}>
            {selectedItem?.bbcLibrarianNotes || ""}
          </div>
        </div>
        <div className={clsx(classes.muDetailWrap, "popupData")}>
          <div
            title={`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}
            className={classes.muLabels}>{`${process.env.REACT_APP_CLIENT_NAME
              ? process.env.REACT_APP_CLIENT_NAME
              : "BBC"
              } Licence Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLicenceNotes || ""}>
            {selectedItem?.bbcLicenceNotes || ""}
          </div>
        </div>
      </>
    );
  };
  calcHeight() {
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height + 65;
  }

  calcHeightinner() {
    const rect = this.toolWrapper
      ? this.toolWrapper.getBoundingClientRect()
      : 0;
    return rect.height - 130;
  }

  getStatus = (id) => {
    const {
      runtime: { loading, runtime },
    } = this.props;
    if (loading) return { name: "", color: "" };
    return __getTrackStatusByID(id, runtime?._statuses || []);
  };

  messageTimeout = null;
  showError = (errorMessage) => {
    clearTimeout(this.messageTimeout);
    this.setState({ errorMessage });
    this.messageTimeout = setTimeout(() => {
      this.setState({ errorMessage: null });
    }, 8000); //timeout interval same as the DownloadLink "messageTimeout"
  };

  render() {
    let selectedItem;
    const {
      classes,
      data: {
        selectedItem: selectedItemForPreview,
        postUpdating,
        showCtagRule,
        history,
        PRSHistoryLoading,
        query,
      },
      updateData: { trackEditing },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
          _mlMetadata,
          _canSeeAdminNotes,
          _extendedTrackPreviewMetadata,
        },
      },
      getTrackHistory,
      prsTrackUnlink,
      prsHistorySearch,
      search,
      prsMechanicalOverride,
      prsSetHistory,
      CreatePrsTrack,
      CreatePrsManualMatchTrack,
      focusItem,
      updatePrsData,
      item,
      isPopOut,
      isInline,
      playerContent,
    } = this.props;

    if (isPopOut) {
      selectedItem = item;
    } else {
      selectedItem = selectedItemForPreview;
    }

    if (selectedItem && selectedItem.id)
      this.generateColsDef(
        (selectedItem[trackFields.musicOrigin.id] || "").toLowerCase()
      );

    const canViewAdminNotes = _PermittedContent(
      [_mlMetadata, _canSeeAdminNotes],
      []
    )
      ? true
      : false;

    const { bookletDlLoading } = this.state;

    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={this.state.errorMessage ? true : false}
              message={this.state.errorMessage}
              className={classes.snackbar}
            />
            {/* {trackEditing && (trackEditing.wsType === "Owned" || trackEditing.wsType === "Master") ? ( */}
            {trackEditing ? (
              <>
                <TrackPreview {...this.props} />
              </>
            ) : selectedItem && selectedItem.id ? (
              <>
                {!isPopOut && (
                  <>
                    <Paper
                      className={clsx(
                        classes.disFlex,
                        classes.buttomOveridden
                      )}>
                      <h2 className={classes.muTitle}>
                        {(selectedItem[trackFields.trackTitle.id] &&
                          Array.isArray(selectedItem[trackFields.trackTitle.id])
                          ? selectedItem[trackFields.trackTitle.id].join(", ")
                          : selectedItem[trackFields.trackTitle.id]) ||
                          t("libraryPreview.na")}
                        <span className={classes.muSubTitle}>
                          {(selectedItem[trackFields.performer.id] &&
                            Array.isArray(selectedItem[trackFields.performer.id])
                            ? selectedItem[trackFields.performer.id].join(", ")
                            : selectedItem[trackFields.performer.id]) ||
                            t("libraryPreview.na")}
                        </span>
                      </h2>
                      <HelpWrap config={helpModules.TSPWH} />
                      <DownloadLink track={selectedItem} showBooklet={true} />
                    </Paper>
                    <div style={{ display: "flex" }}>
                      <div
                        className={classes.trackEditContainer}
                        ref={(div) => (this.toolWrapper = div)}>
                        <Paper>
                          <Box
                            className={classes.artworkHolder}
                            tabIndex="-1"
                            p={1}>
                            <Grid
                              container
                              direction="column"
                              alignItems="center"
                              justify="center"
                              tabIndex="-1">
                              {selectedItem[trackFields.prodArtworkUrl.id] ? (
                                <img
                                  style={{ height: 240, width: trackFields }}
                                  src={AuthSrc(
                                    selectedItem[trackFields.prodArtworkUrl.id]
                                  )}
                                  alt={
                                    selectedItem[trackFields.trackTitle.id] ||
                                    ""
                                  }
                                />
                              ) : (
                                <Grid
                                  container
                                  direction="column"
                                  alignItems="center"
                                  justify="center">
                                  <img
                                    className={"emptyArtwork"}
                                    src={CliIconMain}
                                    alt="Sky Music"
                                  />

                                  {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                                </Grid>
                              )}
                            </Grid>
                            {postUpdating ? null : (
                              <PlayerRef
                                className={classes.playTrackButton}
                                key={selectedItem.id}
                                aria-label="Play"
                                item={selectedItem}
                                popoutFor={PageTableType.SEARCH_TRACKS}
                              />
                            )}
                          </Box>
                        </Paper>
                      </div>
                      <div className={classes.popOutBlock}>
                        {
                          <MetaDataPopOut
                            popoutFor={PageTableType.SEARCH_TRACKS}
                            data={selectedItem}
                          />
                        }
                        {
                          <PrsPopup
                            prsTrackUnlink={prsTrackUnlink}
                            prsHistorySearch={prsHistorySearch}
                            prsmechanicaloverride={prsMechanicalOverride}
                            PRSHistoryLoading={PRSHistoryLoading}
                            popoutFor={PageTableType.SEARCH_TRACKS}
                            mbTrackData={selectedItem}
                            prsTrackData={selectedItem?.prsTrack}
                            updatePrsData={updatePrsData}
                            trackSearch={() => {
                              search(query);
                            }}
                            prsSetHistory={prsSetHistory}
                            CreatePrsTrack={CreatePrsTrack}
                            focusItem={focusItem}
                            mlsearch={search}
                            CreatePrsManualMatchTrack={
                              CreatePrsManualMatchTrack
                            }
                          />
                        }
                        {selectedItem?.prodBookletUrl && (
                          <Button
                            aria-label="Download booklet"
                            title="Download Booklet"
                            onClick={() => {
                              this.setState({ bookletDlLoading: true }, () => {
                                getDownloadBookletLink(
                                  selectedItem.id,
                                  selectedItem?.prodBookletUrl
                                ).then((res) => {
                                  this.setState({ bookletDlLoading: false });
                                  if (res.url) {
                                    var link = document.createElement("a");
                                    link.target = "_blank";
                                    link.rel = "noopener noreferrer";
                                    link.href = res.url;
                                    link.download = res.name;
                                    document.body.appendChild(link);
                                    link.click();
                                    window.URL.revokeObjectURL(link);
                                    link.remove();
                                  } else {
                                    this.showError(
                                      "Sorry, requested download is not available"
                                    );
                                  }
                                });
                              });
                            }}>
                            {!bookletDlLoading ? (
                              <BiDownload />
                            ) : (
                              <CircularProgress
                                size={20}
                                className={classes.preLoader}
                              />
                            )}{" "}
                            <span class="hideInside">Download Booklet</span>
                          </Button>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    {isPopOut && isInline && playerContent && (
                      <Tab
                        label="Now Playing"
                        {...this.a11yProps(7)}
                        value={7}
                      />
                    )}
                    <Tab
                      label={isPopOut ? "Metadata" : "Track Metadata"}
                      {...this.a11yProps(0)}
                      value={0}
                    />
                    {/* {_extendedTrackPreviewMetadata && _extendedTrackPreviewMetadata.orgSpecificMetadata != null && (<Tab label={`${JSON.parse(appConfig.ORG)?.lbl} Specific`} {...this.a11yProps(1)} value={1} />)}  */}
                    {_extendedTrackPreviewMetadata &&
                      _extendedTrackPreviewMetadata.prsMetadata != null && (
                        <Tab label="PRS" {...this.a11yProps(2)} value={2} />
                      )}
                    <Tab label="Tags" {...this.a11yProps(3)} value={3} />
                    {/* <Tab label="All" {...this.a11yProps(4)} value={4} /> */}
                    <Tab label="C-Tag Rules" {...this.a11yProps(5)} value={5} />
                    <Tab label="History" {...this.a11yProps(6)} value={6} />
                  </Tabs>
                </AppBar>
                {isPopOut && isInline && playerContent && (
                  <TabPanel
                    className={classes.trackTabs}
                    value={this.state.tabValue}
                    index={7}>
                    <Paper
                      className={clsx(classes.sidebarDataContainer, "popOutDisplay")}
                      style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div
                        className={classes.sidebarWrappedDataDark}
                        style={{
                          height: `calc(100% - ${this.calcHeightinner()}px)`,
                        }}>
                        <Grid container>{playerContent}</Grid>
                      </div>
                    </Paper>
                  </TabPanel>
                )}
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={0}>
                  {!isPopOut ?
                    <>
                      <Paper
                        className={classes.sidebarDataContainer}
                        style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                        <div
                          className={classes.sidebarWrappedDataDark}
                          style={{
                            height: `calc(100% - ${this.calcHeightinner()}px)`,
                          }}>
                          {this.colsDefAll?.map((id, i) => {
                            const prop = trackFields[id] || {};
                            return !prop.tag
                              ? this.renderMetadata(
                                id,
                                i,
                                classes,
                                selectedItem,
                                t,
                                prop
                              )
                              : null;
                          })}
                          {canViewAdminNotes &&
                            this.renderAdminNotes(selectedItem, classes, t)}
                        </div>
                      </Paper>
                    </> : (<TrackMetadataGrid data={item} classes={classes} />)
                  }
                </TabPanel>

                {/*  <TabPanel
                    className={classes.trackTabs}
                    value={this.state.tabValue}
                    index={1}
                  >
                    <Paper className={classes.sidebarDataContainer} style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div className={classes.sidebarWrappedDataDark} style={{height: `calc(100% - ${this.calcHeightinner()}px)`}}>
                        {_extendedTrackPreviewMetadata && _extendedTrackPreviewMetadata.orgSpecificMetadata != null && Object.values(_extendedTrackPreviewMetadata?.orgSpecificMetadata)?.map((field, i) => {
                          const prop = field || {};
                          return !prop.tag
                            ? this.renderMetadata(
                              field.id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            )
                            : null;
                        })}
                      </div>
                    </Paper>
                  </TabPanel> */}
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={2}>
                  {!isPopOut ?
                    <Paper
                      className={classes.sidebarDataContainer}
                      style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div
                        className={classes.sidebarWrappedDataDark}
                        style={{
                          height: `calc(100% - ${this.calcHeightinner()}px)`,
                        }}>
                        {/* {_extendedTrackPreviewMetadata && _extendedTrackPreviewMetadata.prsMetadata != null && Object.values(_extendedTrackPreviewMetadata?.prsMetadata)?.map((field, i) => {
                        const prop =  field || {};
                        return !prop.tag
                          ? this.renderMetadata(
                            field.id,
                            i,
                            classes,
                            selectedItem,
                            t,
                            prop
                          )
                          : null;
                      })} */}
                        <PrsDataPreview
                          classes={classes}
                          selectedItem={selectedItem}
                        />
                      </div>
                    </Paper>
                    :
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, "popupWindow")}>
                        <PrsDataPreview
                          classes={classes}
                          selectedItem={selectedItem}
                        />
                      </div>
                    </Paper>
                  }

                </TabPanel>

                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={3}>
                  {!isPopOut ?
                    <Paper
                      className={classes.sidebarDataContainer}
                      style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div
                        style={{
                          height: `calc(100% - ${this.calcHeightinner()}px)`,
                        }}
                        className={classes.sidebarWrappedDataDark}>
                        {this.colsDef?.map((id, i) => {
                          const prop = trackFields[id] || {};
                          return prop.tag
                            ? this.renderMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            )
                            : null;
                        })}
                      </div>
                    </Paper>
                    :
                    <Paper className={classes.paperwrap}>
                      <div className={clsx(classes.muListWrap, "popupWindow")}>
                      {this.colsDef?.map((id, i) => {
                          const prop = trackFields[id] || {};
                          return prop.tag
                            ? this.renderMetadata(
                              id,
                              i,
                              classes,
                              selectedItem,
                              t,
                              prop
                            )
                            : null;
                        })}
                      </div>
                    </Paper>
                  }

                </TabPanel>

                {/* <TabPanel
                    className={classes.trackTabs}
                    value={this.state.tabValue}
                    index={4}
                  >
                    <Paper className={classes.sidebarDataContainer} style={{ height: `calc(100% - ${this.calcHeight()}px)` }}>
                      <div className={classes.sidebarWrappedDataDark} style={{height: `calc(100% - ${this.calcHeightinner()}px)`}}>
                        {this.colsDefAll?.map((id, i) => {
                          const prop = trackFields[id] || {};
                          return this.renderMetadata(
                            id,
                            i,
                            classes,
                            selectedItem,
                            t,
                            prop
                          );
                        })}
                      </div>
                    </Paper>
                  </TabPanel> */}
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={5}>
                  <CtagRulePreview  classes={this.props.isPopOut? classes : null}  />
                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={6}>
                  <Paper>
                    {selectedItem &&
                      selectedItem.id &&
                      selectedItem.id in history ? (
                      history[selectedItem.id].length == 0 ? (
                        <div
                          className={clsx(classes.HistoryBlock, "popupWindow")}>
                          <div class={classes.noData}> No History</div>
                        </div>
                      ) : !isPopOut? 
                        (
                        
                          <Paper
                            className={classes.sidebarDataContainer}
                            style={{
                              height: `calc(100% - ${this.calcHeight()}px)`,
                            }}>
                            <div
                              className={classes.sidebarWrappedDataDark}
                              style={{
                                height: `calc(100% - ${this.calcHeightinner()}px)`,
                              }}>
                              <div className={classes.trackHistory}>
                                <TrackSearchHistory
                                  data={history[selectedItem.id]}
                                  classes={classes}
                                  getStatus={(id) => this.getStatus(id)}
                                />
                              </div>
                            </div>
                          </Paper>
                        ) : (
                          <Paper className={classes.paperwrap}>
                            <div
                              className={clsx(
                                classes.muListWrap,
                                "popupWindow"
                              )}>
                              <TrackSearchHistory
                                data={history[selectedItem.id]}
                                classes={classes}
                                getStatus={(id) => this.getStatus(id)}
                              />
                            </div>
                          </Paper>
                        )                      
                      
                    ) : !isPopOut? (
                      <Paper
                        className={classes.sidebarDataContainer}
                        style={{
                          height: `calc(100% - ${this.calcHeight()}px)`,
                        }}>
                        <div
                          className={classes.sidebarWrappedDataDark}
                          style={{
                            height: `calc(100% - ${this.calcHeightinner()}px)`,
                          }}>
                          <CircularProgress className={classes.progress} />
                        </div>
                      </Paper>
                    )
                    :
                    (
                      <Paper className={classes.paperwrap}>
                        <div
                          className={clsx(
                            classes.muListWrap,
                            "popupWindow"
                          )}>
                          <CircularProgress className={classes.progress} />
                        </div>
                      </Paper>
                    )
                    }
                  </Paper>
                </TabPanel>
              </>
            ) : (
              <div className={classes.noData}>
                <img style={{ width: 120 }} src={CliIcon} alt="Sky Music" />
                {/* <MusicNoteIcon style={{ fontSize: 60, marginBottom: 20 }} /> */}
                {/* {t("libraryPreview.noPreview")} */}
              </div>
            )}
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
  updateData: state.mlTrackUpdateReducer,
  runtime: state.clearanceRuntime,
  searchPrs: state.searchPrs,
  orgRuntime: state.orgRuntime,
  users: state.inbox.allUsers,
});

export default connect(mapStateToProps, {
  showCtagRulePreview,
  getTrackHistory,
  loadRuntime,
  clearDownloads,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  search,
  prsSetHistory,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
  focusItem,
  setQuery,
  updatePrsData,
  getActivityCounts,
})(withStyles(styles)(Preview));
